import React from 'react';

export default class Input extends React.Component {
  constructor() {
    super();
    this.state = {

    }
  }
  render() {
    let inp = "";
    this.props.inp.forEach(function(element) {
      inp+=element+" ";
    }, this);
    return (
      <div>
        <input
          type="text"
          value={inp}
          style={
           { width:100+"%" }
          }
          placeholder="wartości oddzielone spacjami, np: '1 2 3 15'"
          onChange={(e)=>{
            let a = e.target.value.split(" ");
            if(a[a.length-1]==="") a.pop();
            this.props.hc(a);
          }}
        />
      </div>);
  }
}

/*
LOAD =11
READ 1
ADD 1
WRITE =5555
WRITE 0
STORE 15
WRITE 15
HALT
*/


// WEBPACK FOOTER //
// ./components/Input.jsx